import { render, staticRenderFns } from "./Gmsq.vue?vue&type=template&id=044c42aa&scoped=true&"
import script from "./Gmsq.vue?vue&type=script&lang=js&"
export * from "./Gmsq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c42aa",
  null
  
)

export default component.exports